import { useEffect, useState } from 'react';

const processingStages = [
  'Analysing Image',
  'Preparing 3D Model',
  'Loading Interactive Viewer',
];

function ProcessingView({ onComplete }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const startedAt = performance.now();
    const duration = 3600;
    let frameId;
    let completeTimer;

    const tick = (time) => {
      const elapsed = Math.min(time - startedAt, duration);
      const eased = 1 - Math.pow(1 - elapsed / duration, 3);
      setProgress(Math.round(eased * 100));

      if (elapsed < duration) {
        frameId = requestAnimationFrame(tick);
      } else {
        completeTimer = window.setTimeout(onComplete, 350);
      }
    };

    frameId = requestAnimationFrame(tick);

    return () => {
      cancelAnimationFrame(frameId);
      window.clearTimeout(completeTimer);
    };
  }, [onComplete]);

  const activeStage = Math.min(
    processingStages.length - 1,
    Math.floor((progress / 100) * processingStages.length),
  );

  return (
    <section className="processing-view" aria-live="polite">
      <div className="processing-card">
        <div className="loader-ring" aria-hidden="true" />
        <p className="eyebrow">Processing</p>
        <h1>Creating your interactive 3D model...</h1>
        <div className="progress-meta">
          <span>{processingStages[activeStage]}</span>
          <strong>{progress}%</strong>
        </div>
        <div className="progress-track" aria-label="Generation progress">
          <div style={{ width: `${progress}%` }} />
        </div>
        <ol className="stage-list">
          {processingStages.map((stage, index) => (
            <li key={stage} className={index <= activeStage ? 'is-active' : ''}>
              <span>{index + 1}</span>
              {stage}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}

export default ProcessingView;
